export default __webpack_public_path__ + "static/The Home_Image 4_carousel 1@2x-379f2a218f767ba6b680f2b607b0c196.jpg";